<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>资源管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-table-result">
      <div class="wrap-table-info-display">
        <section>
          <el-button class="mgr10" type="primary" size="small" @click="handleAdd">新增</el-button>
        </section>
        <span class="table-info-display">
          <span>总条数：</span>
          <span class="alert-text ft16">{{ dataList.length }}</span>
        </span>
      </div>

      <el-table slot="content" :data="dataList" border row-key="id" :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" v-loading="tableLoading">
        <el-table-column align="left" label="资源名称" prop="resourcesName"></el-table-column>

        <el-table-column align="left" label="资源路由" prop="url"></el-table-column>

        <el-table-column align="center" label="上级资源" prop="pResourcesName" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.pResourcesName ? scope.row.pResourcesName : "-" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序编号" prop="sort" width="80"></el-table-column>

        <el-table-column align="center" label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            <el-button type="text" @click="handleAddChildren(scope.row.id, scope.row.resourcesName)">增加子级</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该资源？" @confirmed="handleDelete(scope.row.id)">
              <span class="color-danger">删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <ResourceDialog :dialogVisible.sync="resourceDialogVisible" :id="resourceId" :parentResource="parentResource" @onSuccess="loadTableData()" />
  </div>
</template>

<script>
import ResourceDialog from "../components/ResourceDialog.vue";
export default {
  components: {
    ResourceDialog,
  },
  data() {
    return {
      tableLoading: false,
      dataList: [],
      resourceDialogVisible: false,
      resourceId: "",
      parentResource: {},
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/resources/findMenuTree",
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              // pResourcesName
              this.dataList = this._setPResourcesName(res.body.data);
            } else {
              this.dataList = [];
            }
          } else {
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 设置pResourcesName
     */
    _setPResourcesName(data, pResourcesName = "-") {
      return (function func(data, pResourcesName = "-") {
        for (let i = 0, len = data.length; i < len; i++) {
          data[i] = Object.assign({}, data[i], {
            pResourcesName: pResourcesName,
          });

          if (data[i].children.length > 0) {
            func(data[i].children, data[i].resourcesName);
          }
        }
        return data;
      })(data, (pResourcesName = "-"));
    },
    handleAdd() {
      this.resourceDialogVisible = true;
      this.resourceId = "";
      this.parentResource = {
        parentId: "",
        parentName: "",
      };
    },
    handleEdit(id) {
      this.resourceDialogVisible = true;
      this.resourceId = id;
    },
    handleDelete(id) {
      this.$http({
        url: global.apiUrl + `/resources/menuDelete/${id}`,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleAddChildren(id, resourcesName) {
      this.resourceDialogVisible = true;
      this.resourceId = "";
      this.parentResource = {
        parentId: id,
        parentName: resourcesName,
      };
    },
  },
};
</script>
<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
